"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEMPLATE_SEARCH = exports.TEMPLATE_RECOMMEND = exports.TEMPLATE_NAME_VALIDATE = exports.USE_TEMPLATE = exports.TEMPLATE_ALBUMS_RECOMMEND = exports.TEMPLATE_ALBUMS = exports.TEMPLATE_DIRECTORY = exports.DELETE_TEMPLATE = exports.SPACE_TEMPLATES = exports.TEMPLATE_CATEGORIES = exports.TEMPLATE_LIST = exports.OFFICIAL_TEMPLATE_CATEGORY = exports.CREATE_TEMPLATE = void 0;
// =============== Template related =======================
exports.CREATE_TEMPLATE = '/template/create';
exports.OFFICIAL_TEMPLATE_CATEGORY = '/template/categoryList';
exports.TEMPLATE_LIST = '/template/list';
/*
* Get official template category content
 */
exports.TEMPLATE_CATEGORIES = '/template/categories/:categoryCode';
/*
* Load all templates of space station
 */
exports.SPACE_TEMPLATES = '/spaces/:spaceId/templates';
exports.DELETE_TEMPLATE = '/template/delete/';
exports.TEMPLATE_DIRECTORY = '/template/directory';
/*
  * Template topic content
  */
exports.TEMPLATE_ALBUMS = '/template/albums/:albumId';
/*
  * Template topic recommendation
  */
exports.TEMPLATE_ALBUMS_RECOMMEND = '/template/albums/recommend';
exports.USE_TEMPLATE = '/template/quote';
exports.TEMPLATE_NAME_VALIDATE = '/template/validate';
exports.TEMPLATE_RECOMMEND = '/template/recommend';
exports.TEMPLATE_SEARCH = '/template/global/search';
//# sourceMappingURL=url.template.js.map